import FlexSearch from 'flexsearch/dist/flexsearch.light.js'
import Mark from 'mark.js'

export default function faqSearch ($container) {
  let searchIndex = FlexSearch.create()

  ;[].slice.call($container.querySelectorAll('[data-faq-id]')).forEach($faq => {
    searchIndex.add(
      parseInt($faq.getAttribute('data-faq-id'), 10),
      `${$faq.querySelector('h2').textContent.trim()}\n${$faq
        .querySelector('.accordion-content')
        .textContent.trim()}`
    )
  })

  let $$faqs = [].slice.call($container.querySelectorAll('[data-faq-id]'))

  let $noResults = document.createElement('p')
  $noResults.className = 'mt-30 sm:mt-40 text-center'

  let markers = $$faqs.map($faq => new Mark($faq))

  function search (term) {
    if (term === '') {
      $$faqs.forEach(($faq, i) => {
        $faq.hidden = false

        markers[i].unmark()
      })

      $noResults.parentNode && $noResults.parentNode.removeChild($noResults)
      return
    }

    let results = searchIndex.search(term)

    if (results.length === 0) {
      $noResults.innerHTML = `No results for “${escapeHtml(term)}”`
      $container
        .querySelector('.accordion')
        .insertBefore(
          $noResults,
          $container.querySelector('.accordion').firstElementChild
        )
    } else {
      $noResults.parentNode && $noResults.parentNode.removeChild($noResults)
    }

    $$faqs.forEach(($faq, i) => {
      let matches =
        results.indexOf(parseInt($faq.getAttribute('data-faq-id'), 10)) !== -1
      if (matches) {
        markers[i].unmark()
        markers[i].mark(term, {
          className: 'bg-yellow'
        })
      }
      $faq.hidden = !matches
    })
  }

  return {
    index: searchIndex,
    search
  }
}

function escapeHtml (html) {
  let text = document.createTextNode(html)
  let p = document.createElement('p')
  p.appendChild(text)
  return p.innerHTML
}



// WEBPACK FOOTER //
// ./src/js/faq-search.js